exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".configurator[data-v-e846e258]{margin-bottom:150px}", ""]);

// exports
